import moment from 'moment';

import * as modal from '../modal/modal';
import * as fancybox from './fancybox';

//NOTE: THIS FILE IS LOADED BY THE ERROR PAGES.
export const ButtonKeys = { EnterKey: 13, EscapeKey: 27, TabKey: 9 };

$(() => {
  if (window.cookieSupportUrl && !navigator.cookieEnabled) {
    window.location.href = window.cookieSupportUrl;
  }

  moment.locale(UiText.locale());

  const fancyboxUtils = fancybox.Utils.getInstance();

  function setFormDefaultButton(button: JQuery, limitToButton: boolean) {
    const isFullyVisible = (element: JQuery) => {
      return element.is(':visible') && element.parents().length == element.parents().filter(':visible').length;
    };

    // use the document if it shouldn't just apply to the link itself.
    const containerItem = limitToButton ? button : document;

    $(containerItem).keypress(function (e) {
      if (e.which == ButtonKeys.EnterKey && !$(e.target).is('textarea') && isFullyVisible(button)) {
        return false;
      }

      return true;
    });

    $(containerItem).keyup(function (e) {
      if (e.which == ButtonKeys.EnterKey && !$(e.target).is('textarea') && isFullyVisible(button)) {
        button.click();
        return false;
      }
      return true;
    });
  }

  $('form').each(function () {
    $(this)
      .find('.formDefaultButton')
      .each(function () {
        setFormDefaultButton($(this), false);
      });

    $(this)
      .find('a, .formCancelButton')
      .each(function () {
        const current = $(this);
        if (!current.hasClass('formDefaultButton')) {
          setFormDefaultButton(current, true);
        }
      });

    // disables buttons after form submission on successful validation if any
    $(this).submit(function () {
      const thisForm = $(this);

      if (typeof thisForm.valid == 'function' && thisForm.valid()) {
        thisForm.find(':disabled').prop('disabled', false);
        if (!thisForm.hasClass('dontDisable')) {
          $(document).find('input[type=submit]').prop('disabled', true).addClass('disabledNav');
        }

        modal.ShowProcessing();
      } else {
        $(document).trigger('seahorse.validationFailed');
      }
    });
  });

  $('.alwaysDefaultButton').each(function () {
    setFormDefaultButton($(this), false);
  });

  // pass through escape press to fancybox parent for cancel handling
  $(document).on('keydown', (event) => {
    if (event.keyCode == ButtonKeys.EscapeKey) {
      if (parent && parent !== window && parent.$('#fancybox-close').is(':visible')) {
        const newEvent = parent.$.Event('keydown', { keyCode: event.keyCode });
        parent.$(parent.document).trigger(newEvent);
        event.preventDefault();
      }
    }
  });

  // if you want to override the datepicker position implement "DatePosition(inst, offset, isFixed)"
  const datePositionFunc = window.DatePosition
    ? window.DatePosition
    : (inst: { input: JQuery; dpDiv: JQuery }, offset: { top: number; left: number }): { top: number; left: number } => {
        offset.left = inst.input.offset()!.left;

        offset.top = inst.input.offset()!.top - inst.dpDiv.outerHeight()!;
        return offset;
      };

  $.extend($.datepicker, {
    _checkOffset: datePositionFunc,
  });

  // Use default settings if language is English-like (en, en-GB, en-IN, or en-US)
  const locale = UiText.locale().slice(0, 2) !== 'en' ? UiText.locale() : '';
  $.datepicker.setDefaults($.datepicker.regional[locale]);

  // attach date picker to applicable fields
  $('.datePicker').each(function () {
    $(this).datepicker({
      showAnim: '',
      showOn: 'both',
      buttonImage: window.rootDirectory + 'images/Calendar_scheduleHS.png',
      buttonImageOnly: true,
      changeMonth: true,
      changeYear: true,
      showOtherMonths: true,
      selectOtherMonths: true,
      firstDay: 1,
      dateFormat: 'yy-mm-dd',
      onSelect: (dateText, instance) => {
        if (window.onDatePickerSelect) {
          window.onDatePickerSelect(dateText, instance);
        }
      },
      onClose: (_, instance) => {
        if (typeof instance.input.valid == 'function') {
          instance.input.valid();
        }
      },
    });
    if ($(this).prop('disabled')) {
      $(this).datepicker().datepicker('disable');
    }
  });

  const changeServiceProviderLnk = $('#ChangeServiceProviderLnk');
  if (changeServiceProviderLnk.length > 0) {
    fancyboxUtils.createWithCloseFunction($('#ChangeServiceProviderLnk'), 410, 482, undefined, undefined);
  }

  setUserServiceProviderWidth();
  $(window).resize(setUserServiceProviderWidth);

  // The upgrade to MVC4 added a default validation for date fields which breaks in IE because it checks against the current culture format for dates.
  if ($.validator != null) {
    // Disabled this default validation for now.
    $.validator.addMethod('date', () => true, '');
  }

  // Prevent scrolling to the top of the document, # only used for anchor elements with no where to go
  $('a[href="#"]').click((e) => {
    e.preventDefault();
  });

  // Ensure selectors only match one thing. Follows the great onclick to jquery selector migration
  $.extend({
    singleElement: (selector: string) => {
      // JQuery will only return 1 element if 1 ID is passed, adding extra selector as a filthy workaround
      const match = $(selector + ', .noMatchSelector');
      const count = match.length;
      if (count !== 1) {
        throw 'Error: ' + count + " element(s) for selector '" + selector + "'";
      }
      return match;
    },
  });
});

$(document).on('ajaxError', function (_, jqXHR) {
  if (jqXHR.status === 401) {
    RedirectToLogin();
  }
});

function setUserServiceProviderWidth() {
  // the minimum width of the navigation bar is set to 970 in the css, otherwise it is set to 90% of the window width.

  const windowWidth = Math.max($(window).width()! * 0.9, 970);

  const maxUserServiceProviderWidth = windowWidth - 560;
  const usernameLi = $('ul#user li#username');
  const serviceProviderLi = $('ul#user li#serviceProviderName');
  usernameLi.css('width', '');
  serviceProviderLi.css('width', '');

  const userWidth = usernameLi.width()!;

  const serviceProviderWidth = serviceProviderLi.width()!;

  if (userWidth + serviceProviderWidth > maxUserServiceProviderWidth) {
    // if both widths are bigger than half.
    const halfMaxWidth = maxUserServiceProviderWidth / 2;
    if (userWidth > halfMaxWidth && serviceProviderWidth > halfMaxWidth) {
      usernameLi.css('width', halfMaxWidth);
      serviceProviderLi.css('width', halfMaxWidth);
    } else if (userWidth > halfMaxWidth) {
      usernameLi.css('width', maxUserServiceProviderWidth - serviceProviderWidth);
    } else {
      serviceProviderLi.css('width', maxUserServiceProviderWidth - userWidth);
    }
  }
}

export function RedirectToLogin(): void {
  const windowObj = window.parent ?? window;

  const url = new URL(windowObj.location.toString());
  url.searchParams.delete('returnUrl');
  url.searchParams.delete('ReturnUrl');
  url.searchParams.delete('expired');

  const newReturnUrl = url.pathname + url.search;

  url.searchParams.set('returnUrl', newReturnUrl);
  url.searchParams.set('expired', 'true');

  windowObj.location.replace(url.toString());
}

export function endsWith(str: string, suffix: string): boolean {
  return str != null && str.indexOf(suffix, str.length - suffix.length) !== -1;
}

/* start/end date generation handlers */
export function dateChangedHandler(senderId: string): void {
  const startDate = window.startDate;
  const endDate = window.endDate;
  if (startDate && endDate) {
    if (startDate.prop('id') == senderId) {
      assignAutoDate(startDate, endDate, 1, -1);
    } else if (endDate.prop('id') == senderId) {
      assignAutoDate(endDate, startDate, -1, 1);
    }
    startDate.valid();
    endDate.valid();
  }
}

export function assignAutoDate(date1: JQuery, date2: JQuery, yearOffset: number, dayOffset: number): void {
  const date1Val = date1.val() as string | undefined;
  const date2Val = date2.val() as string | undefined;
  if (date1Val && !date2Val) {
    const adjustedDate = addOffsetToDate(date1Val, yearOffset, 0, dayOffset);
    if (adjustedDate) {
      date2.val(adjustedDate);
    }
  }
}

export function addOffsetToDate(date: string, yearOffset: number, monthOffset: number, dayOffset: number): string | undefined {
  const parsedDate = moment(date, window.shDateFormat, true);
  if (parsedDate.isValid()) {
    return parsedDate.add(yearOffset, 'years').add(monthOffset, 'months').add(dayOffset, 'days').format(window.shDateFormat);
  }
  return undefined;
}

export function removeValidationFromField(fieldSelector: string): void {
  $(fieldSelector).removeClass('input-validation-error');
  $('[data-valmsg-for="' + $(fieldSelector).prop('id') + '"]')
    .addClass('field-validation-valid')
    .removeClass('field-validation-error')
    .text('');
}

export function toTitleCase(input: string): string {
  //make all the words title case to start with.
  let output = input.replace(/\w\S+/g, function (t) {
    return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
  });

  const lowerCaseWords = [
    'A',
    'An',
    'The',
    'And',
    'But',
    'Or',
    'For',
    'Nor',
    'As',
    'At',
    'By',
    'For',
    'From',
    'Is',
    'In',
    'Into',
    'Near',
    'Of',
    'On',
    'Onto',
    'To',
    'With',
  ];
  let i;
  for (i = 0; i < lowerCaseWords.length; i++) {
    const lower = lowerCaseWords[i];
    //requires spaces before the string as we ignore the first entry.
    output = output.replace(new RegExp('\\s' + lower + '\\b', 'g'), function (t) {
      return t.toLowerCase();
    });
  }

  //some words should always be upper case.
  const upperCaseWords = ['Id'];
  for (i = 0; i < upperCaseWords.length; i++) {
    const upper = upperCaseWords[i];
    output = output.replace(new RegExp('\\b' + upper + '\\b', 'g'), function (t) {
      return t.toUpperCase();
    });
  }

  return output;
}

export function setupBlockUIDefaults(): void {
  if ($.blockUI && $.blockUI.defaults) {
    //setting the mask defaults.
    $.blockUI.defaults.css.width = 'auto';
    $.blockUI.defaults.css.minWidth = '120px';
    $.blockUI.defaults.css.border = '10px solid #ECECEC';
    $.blockUI.defaults.css.color = '#6E6E6E';
    $.blockUI.defaults.css.padding = '5px';
    $.blockUI.defaults.fadeIn = 200;
    $.blockUI.defaults.fadeOut = 200;
    $.blockUI.defaults.overlayCSS = { backgroundColor: '#BBB', opacity: 0.7 };
    $.blockUI.defaults.ignoreIfBlocked = true;
  }
}

export function centerMask(id: string): void {
  const toMask = $('#' + id);
  const maskMessageElement = toMask.find('.blockElement');
  const adjustment = 30;

  const toMaskHeight = toMask.height()!;

  const toMaskMessageHeight = maskMessageElement.height()!;

  const toMaskWidth = toMask.width()!;

  const toMaskMessageWidth = maskMessageElement.width()!;
  maskMessageElement.css('top', (toMaskHeight - toMaskMessageHeight - adjustment) / 2 + 'px');
  maskMessageElement.css('left', (toMaskWidth - toMaskMessageWidth - adjustment) / 2 + 'px');
}

// function used for the last column in a table where extra padding is needed on the right hand side to avoid the text going under the scrollbar.
export function cellWrappingLast(_: string, tv: string): string {
  return 'style="white-space: normal;padding-right: 21px;padding-top: 2px;padding-bottom: 2px;" title="' + tv + '"';
}

export function loadSeahorseDataShared(id: string, data: JqGrid.Data): void {
  clearGrid(id);
  const grid = $('#' + id);
  grid.setGridParam({ datatype: 'jsonstring' });
  grid[0].addJSONData(data);

  // prevents firefox displaying silly lines around tds in grids when you control click.
  if ($.browser.mozilla) {
    $('#' + id + ' td').mousedown(function (e) {
      e.preventDefault();
    });
  }
}

export function clearGrid(id: string): void {
  $('#' + id).clearGridData();
}

export function addRevisionToURL(url: string): string {
  let parsedUrl;
  let canParse = true;
  try {
    parsedUrl = new URL(url);
  } catch (_e) {
    canParse = false;
    parsedUrl = new URL(url, window.location.origin);
  }
  parsedUrl.searchParams.set(window.urlCacheKey, window.urlBuildTimeHex);
  return parsedUrl.toString().substring(canParse ? 0 : window.location.origin.length);
}
